<!--
  ~ Copyright © 2025 Gavin Sawyer. All rights reserved.
  -->

<div class="harness" #htmlDivElement
  (click)="$event.stopPropagation();"
  (keydown)="$event.key === 'Escape' || $event.stopPropagation();"
  tabindex="-1">
  <div class="between" #innerHtmlDivElement><ng-container *ngTemplateOutlet="contentTemplate" /></div>
</div>

<ng-template #badgeSymbolTemplate>
  @if (containerDirective.badgeSymbolTemplateRef$(); as badgeSymbolTemplateRef) {<div id="badgeSymbol">
    <ng-container *ngTemplateOutlet="badgeSymbolTemplateRef" />
  </div>}
</ng-template>
<ng-template #contentTemplate>
  @if (itemTemplateRefs$()[0]; as itemTemplateRef) {<!--suppress CssUnknownProperty --><div [style.--bowstring--scroll-stack--item--index]="1"><div><ng-container *ngTemplateOutlet="itemTemplateRef" /></div></div>}
  @defer {@for (itemTemplateRef of itemTemplateRefs$().slice(1); track $index) {<!--suppress CssUnknownProperty --><div [style.--bowstring--scroll-stack--item--index]="$index + 2"><div><ng-container *ngTemplateOutlet="itemTemplateRef" /></div></div>}}
  <ng-container *ngTemplateOutlet="badgeSymbolTemplate" />
</ng-template>
